export default __webpack_public_path__ + "static/media/1550.d6d65102.png";